var styles = {"container":"TextArea-module_container__VlU-M","input":"TextArea-module_input__IRm3p","count":"TextArea-module_count__8bnGN","error":"TextArea-module_error__SBQ96","disabled":"TextArea-module_disabled__iRdKj"};

export { styles as default };
//# sourceMappingURL=TextArea.module.scss.js.map
